<div class="content repository-page">
  <div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <div>
        <h1 class="dashboard-title mb-1">Repository</h1>
        <p class="repo-subtitle mb-0">Client-specific group plans approved by a 100% audit</p>
      </div>
      <span class="repo-readonly-label"><i class="fa fa-lock mr-1"></i> Audited data · Read only</span>
    </div>

    <div class="table-panel p-4">
      <div class="repo-table-heading d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 class="mb-1">Audited Group Plans</h5>
          <small class="text-muted">Only audit-approved group-plan records are listed.</small>
        </div>
        <div class="repo-table-actions">
          <button type="button" class="btn btn-outline-secondary btn-sm repo-filter-trigger"
                  cdkOverlayOrigin #filterOrigin="cdkOverlayOrigin"
                  [class.repo-filter-trigger-active]="activeFilterCount > 0"
                  (click)="toggleFilters()"
                  [attr.aria-expanded]="filtersExpanded"
                  aria-controls="repo-filter-fields"
                  aria-haspopup="dialog">
            <i class="fas fa-filter mr-1 repo-filter-icon" aria-hidden="true"></i>
            Filters
            <span *ngIf="activeFilterCount > 0" class="repo-active-filter-count">{{activeFilterCount}}</span>
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="loadRepository()"
                  [disabled]="loading || !authService.hasRole('audit-view')">
            <i class="fa fa-refresh mr-1" aria-hidden="true"></i> Refresh
          </button>

          <ng-template cdkConnectedOverlay
                       [cdkConnectedOverlayOrigin]="filterOrigin"
                       [cdkConnectedOverlayOpen]="filtersExpanded"
                       [cdkConnectedOverlayPositions]="filterOverlayPositions"
                       [cdkConnectedOverlayHasBackdrop]="true"
                       cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                       (backdropClick)="closeFilters()"
                       (detach)="closeFilters()">
            <section class="repo-filter-popover" role="dialog" aria-label="Filter audited group plans">
              <div class="repo-filter-popover-header">
                <strong><i class="fas fa-filter mr-2 repo-filter-icon" aria-hidden="true"></i>Filters</strong>
                <button type="button" class="repo-filter-close" (click)="closeFilters()"
                        aria-label="Close filters">
                  <i class="fas fa-times" aria-hidden="true"></i>
                </button>
              </div>
              <form id="repo-filter-fields" class="repo-filter-grid" (ngSubmit)="applySearch()">
                <div class="repo-filter-field">
                  <label for="repo-group-number">Group Number</label>
                  <input id="repo-group-number" name="groupNumber" [(ngModel)]="groupNumber"
                         class="form-control" type="text" placeholder="Search group number"
                         autocomplete="off">
                </div>
                <div class="repo-filter-field">
                  <label for="repo-plan-name">Plan Name</label>
                  <input id="repo-plan-name" name="planName" [(ngModel)]="planName"
                         class="form-control" type="text" placeholder="Search plan name (optional)"
                         autocomplete="off">
                </div>
                <div class="repo-filter-field">
                  <label for="repo-benefit-domain">Benefit Domain</label>
                  <select id="repo-benefit-domain" class="form-control" name="benefitDomain"
                          [(ngModel)]="benefitDomain">
                    <option value="">All Domains</option>
                    <option value="DENTAL">Dental</option>
                    <option value="MEDICAL">Medical</option>
                  </select>
                </div>
                <div class="repo-filter-actions">
                  <button class="repo-reset-button" type="button" (click)="clearSearch()"
                          [disabled]="loading || (!groupNumber && !planName && activeFilterCount === 0)">
                    Reset
                  </button>
                  <button class="repo-apply-button" type="submit" [disabled]="loading">
                    Apply Filters
                  </button>
                </div>
              </form>
            </section>
          </ng-template>
        </div>
      </div>

      <div *ngIf="errorMessage && !loading" class="alert alert-danger mb-3" role="alert">
        {{errorMessage}}
        <button *ngIf="authService.hasRole('audit-view')" type="button"
                class="btn btn-link btn-sm" (click)="loadRepository()">Retry</button>
      </div>

      <div class="table-responsive table-scroll-x">
        <table class="table table-sm repo-table">
          <thead>
            <tr>
              <th scope="col">Sr. No.</th>
              <th scope="col">Group Number</th>
              <th scope="col">Plan Name</th>
              <th scope="col">Plan Type</th>
              <th scope="col">Domain</th>
              <th scope="col">Insurance</th>
              <th scope="col">Audit Status</th>
              <th scope="col">Auditor</th>
              <th scope="col">Audited At</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let plan of tableData; let i = index">
              <td>{{pageIndex * pageSize + i + 1}}</td>
              <td class="repo-group-number">{{plan.groupNumber || '-'}}</td>
              <td class="repo-plan-name">{{plan.planName || '-'}}</td>
              <td>{{plan.planType || '-'}}</td>
              <td><span class="repo-domain-pill" [class.medical]="plan.benefitDomain === 'MEDICAL'">{{plan.benefitDomain === 'MEDICAL' ? 'Medical' : 'Dental'}}</span></td>
              <td>{{plan.insuranceName || '-'}}</td>
              <td>
                <span *ngIf="plan.audit?.audited" class="badge-soft badge-verified">
                  <i class="fa fa-check-circle mr-1" aria-hidden="true"></i> Audited
                </span>
                <span *ngIf="!plan.audit?.audited" class="text-muted">-</span>
              </td>
              <td>{{plan.audit?.auditor || '-'}}</td>
              <td>{{plan.audit?.auditedAt ? (plan.audit.auditedAt | date:'dd MMM yyyy, h:mm a') : '-'}}</td>
              <td>
                <button type="button" class="repo-view-button" (click)="viewPlan(plan)"
                        [attr.aria-label]="'View audited plan ' + (plan.groupNumber || plan.groupId)">
                  <i class="fa fa-eye mr-1" aria-hidden="true"></i> View Details
                </button>
              </td>
            </tr>
            <tr *ngIf="!loading && !errorMessage && tableData.length === 0">
              <td colspan="10" class="text-center repo-empty-state">
                <i class="fa fa-folder-open-o d-block mb-2" aria-hidden="true"></i>
                No audited group plans found for the selected client and filters.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="loading" class="repo-loading text-center" role="status">
        <i class="fa fa-spinner fa-spin mr-2" aria-hidden="true"></i> Loading audited plans...
      </div>

      <div *ngIf="totalRecord > 0 && !errorMessage" class="repo-pagination d-flex justify-content-end align-items-center mt-3">
        <mat-paginator [length]="totalRecord" [pageIndex]="pageIndex" [pageSize]="pageSize"
                       [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Audited repository pages"
                       showFirstLastButtons (page)="onPageChange($event)">
        </mat-paginator>
        <mat-form-field appearance="outline" class="page-selector ml-2">
          <mat-label>Go to Page</mat-label>
          <mat-select [value]="pageIndex" (selectionChange)="jumpToPage($event.value)">
            <mat-option *ngFor="let page of totalPagesArray" [value]="page - 1">{{page}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>

<div *ngIf="detailsVisible" class="repo-modal-backdrop" (click)="closeDetails()">
  <section class="repo-modal" role="dialog" aria-modal="true" aria-labelledby="repo-detail-title"
           (click)="$event.stopPropagation()">
    <header class="repo-modal-header d-flex justify-content-between align-items-start">
      <div>
        <p class="repo-modal-eyebrow mb-1">AUDIT REPOSITORY</p>
        <h2 id="repo-detail-title" class="mb-1">{{selectedPlan?.planName || 'Audited Plan Details'}}</h2>
        <p class="mb-0 text-muted">Group {{selectedPlan?.groupNumber || selectedGroupId}}</p>
      </div>
      <button type="button" class="repo-close-button" (click)="closeDetails()" aria-label="Close audited plan details">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </header>
    <div class="repo-modal-body">
      <div *ngIf="detailsLoading" class="repo-loading text-center" role="status">
        <i class="fa fa-spinner fa-spin mr-2" aria-hidden="true"></i> Loading audited plan details...
      </div>
      <div *ngIf="detailsError && !detailsLoading" class="alert alert-danger" role="alert">
        {{detailsError}}
        <button type="button" class="btn btn-link btn-sm" (click)="retryDetails()">Retry</button>
      </div>

      <ng-container *ngIf="!detailsLoading && !detailsError && selectedPlan">
        <div class="repo-summary-grid mb-4">
          <div><small>Group Number</small><strong>{{selectedPlan.groupNumber || '-'}}</strong></div>
          <div><small>Plan Type</small><strong>{{selectedPlan.planType || '-'}}</strong></div>
                <div><small>Domain</small><strong>{{selectedPlan.benefitDomain === 'MEDICAL' ? 'Medical' : 'Dental'}}</strong></div>
          <div><small>Insurance</small><strong>{{selectedPlan.insuranceName || '-'}}</strong></div>
          <div><small>Audit Status</small>
            <strong class="repo-audited-text">{{selectedPlan.audit?.audited ? 'Audited' : '-'}}</strong>
          </div>
          <div><small>Auditor</small><strong>{{selectedPlan.audit?.auditor || '-'}}</strong></div>
          <div><small>Audited At</small>
            <strong>{{selectedPlan.audit?.auditedAt ? (selectedPlan.audit.auditedAt | date:'dd MMM yyyy, h:mm a') : '-'}}</strong>
          </div>
          <div><small>Last Audit ID</small><strong>{{selectedPlan.audit?.lastAuditId || '-'}}</strong></div>
        </div>

        <div *ngFor="let section of detailSections" class="repo-benefit-section">
          <h3>{{section.title}}</h3>
          <p *ngIf="section.records.length === 0" class="repo-no-records">No records returned for this section.</p>
          <div *ngFor="let record of section.records" class="repo-benefit-record">
            <h4 *ngIf="record.title">{{record.title}}</h4>
            <div *ngFor="let field of record.fields" class="repo-detail-field">
              <span class="repo-detail-label">{{field.label}}</span>
              <span class="repo-detail-value">{{field.value}}</span>
            </div>
          </div>
        </div>

        <p *ngIf="detailSections.length === 0" class="repo-no-records">
          No additional benefits were returned for this audited plan.
        </p>
      </ng-container>
    </div>
    <footer class="repo-modal-footer">
      <span><i class="fa fa-lock mr-1" aria-hidden="true"></i> Verified reference data · Read only</span>
      <button class="btn btn-secondary" type="button" (click)="closeDetails()">Close</button>
    </footer>
  </section>
</div>
